import React from "react";
import NoDataMessage from "./NoDataMessage";
interface DetailsTableColumn {
  label: string;
  key: string;
  minWidth?: string;
}
export default function DetailsTable({ rows, columns }) {
  return (
    <>
      {!rows || rows.length === 0 ? (
        <NoDataMessage />
      ) : (
        <div className="overflow-x-auto">
          <table className="table table-xs w-full text-xs">
            <thead>
              <tr className="text-left bg-[#4F4E4E] text-white">
                {columns.map((column: DetailsTableColumn) => (
                  <th
                    className="pr-2 pl-1 border-black border"
                    key={column.key}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {columns.map((column) => (
                    <td
                      style={{ minWidth: column.minWidth + "px" }}
                      className={`${
                        i % 2 === 0 ? "bg-[#F9F6DF]" : ""
                      } text-left border border-black pl-1 `}
                      key={column.key}
                    >
                      {row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
